import(/* webpackMode: "eager" */ "/Users/lorion/Documents/code/clipglobe/web/app/[locale]/scenarios/[slug]/scenario.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/lorion/Documents/code/clipglobe/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/Users/lorion/Documents/code/clipglobe/web/node_modules/next/dist/client/app-dir/link.js");
